/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AuthInterceptor } from './auth.interceptor';
import { CustomJsonInterceptor, CustomJsonParser, JsonParser } from './custom-json.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders: Provider = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CustomJsonInterceptor, multi: true },
    { provide: JsonParser, useClass: CustomJsonParser }
];